<app-cms-top-bar></app-cms-top-bar>
<div id="wrapper">
    <app-cms-side-bar [active]="'page-management'"></app-cms-side-bar>
    <div id="content-wrapper">

        <div class="container-fluid">
            <p class="title">การจัดการสิทธิ์การใช้งาน</p>

            <!-- Form  -->
            <div class="card mb-3">
                <div class="card-body p-3">
                    <div class="table-responsive" style="overflow-x: hidden;">
                        <div class="row">
                            <div class="col-sm-6 col-md-3 col-lg-2">
                                <p style="text-align: right; padding-top: 7px;">สิทธิ์การใช้งาน :</p>
                            </div>
                            <div class="col-sm-6 col-md-3 col-lg-3 mt-1">
                                <select class="form-select" aria-label="Default select example" (change)="get_manage_role($event.target.value)">
                                    <option selected disabled hidden>เลือก</option>
                                    <option value="Admin">Admin</option>
                                    <option value="Executive">ผู้บริหารกรม</option>
                                    <option value="Central_agency">หน่วยงานส่วนกลาง</option>
                                    <option value="District_inspector">ผู้ตรวจการเขต</option>
                                    <option value="Provincial_officials">ส่วนจังหวัด</option>
                                </select>
                            </div>
                        </div>
                        <div class="row" *ngIf="open_ == true">
                            <div class="col mt-4 text-center">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>หัวข้อ</th>
                                            <th>ตัวเลือก</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let list of role_data; let i = index">
                                        <tr>
                                            <td>{{list.menu}}</td>
                                            <td style="width: 30px;">
                                                <label class="switch">
                                                    <input type="checkbox" [(ngModel)]="list.status"
                                                        (click)="onChange(i)">
                                                    <span class="slider round"></span>
                                                </label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row" *ngIf="open_ == true">
                            <div class="col text-right">
                                <button type="button" class="btn btn-primary btn-sty" (click)="submit()">บันทึก</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <router-outlet></router-outlet>
        </div>
    </div>
</div>
